import {useEffect} from 'react';

import {openLandingUrl} from '@zzng/common/utils/openLandingUrl';

import {LOCAL_STORAGE_KEY} from '@/root/constants/keys';
import usePopup, {HomeEventPopupProps} from '@/root/hooks/usePopup';
import {savePopupDateByRevision} from '@/root/hooks/useTemporaryHiddenPopup';

import Popup from '@/shared/components/Popup/Layout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useHistoryBackAOS from '@/shared/hooks/useHistoryBackAOS';
import useTiara from '@/shared/hooks/useTiara';

const HomeEventPopup = ({imageUrl, landingUrl, revision}: HomeEventPopupProps) => {
  const {trackPage, trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME, customProps: {revision}});
  const {closePopup} = usePopup();

  useHistoryBackAOS(closePopup);

  const handleDoNotShowAgain = () => {
    savePopupDateByRevision(LOCAL_STORAGE_KEY.HOME_EVENT_POPUP_DATE, revision);
    trackEvent({action: TIARA_ACTION.EVENT_POPUP_DO_NOT_SHOW_AGAIN_CLICK});
    closePopup();
  };

  const handleClose = () => {
    trackEvent({action: TIARA_ACTION.EVENT_POPUP_CLOSE_VIEW});
    closePopup();
  };

  const handleOpenLandingUrl = () => {
    trackEvent({action: TIARA_ACTION.EVENT_POPUP_CLICK});
    openLandingUrl(landingUrl);
    closePopup();
  };

  useEffect(() => {
    trackPage({action: TIARA_ACTION.EVENT_POPUP_VIEW});
  }, []);

  return (
    <Popup className="popup_event">
      <div className="thumb_image">
        <button type="button" className="btn_thumb" onClick={handleOpenLandingUrl}>
          <img src={imageUrl} className="img_g" />
          <span className="screen_out">새창열림</span>
        </button>
      </div>
      <Popup.GroupButton>
        <button type="button" className="btn_left" onClick={handleDoNotShowAgain}>
          다시보지 않기
        </button>
        <button type="button" className="btn_right" onClick={handleClose}>
          닫기
        </button>
      </Popup.GroupButton>
    </Popup>
  );
};

export default HomeEventPopup;
